import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="font-display text-2xl text-white/40 animate-pulse">Načítání…</div>
      </div>
    );
  if (!user) return <Navigate to="/prihlaseni" replace />;
  return children;
}
